/**
 * Fires Klaviyo "Added to Cart" when Empire's AddToCartFlyout / ajax cart
 * bypasses Klaviyo's default listeners (intercepted form submit + jQuery POST).
 */
(function () {
  window._learnq = window._learnq || [];

  function absoluteUrl(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    if (url.indexOf('http') === 0) return url;
    return window.location.origin + url;
  }

  function centsToDollars(cents) {
    if (cents == null || cents === '') return 0;
    var n = Number(cents);
    if (Number.isNaN(n)) return 0;
    return Math.round(n) / 100;
  }

  function buildPropsFromLineItem(item) {
    if (!item || typeof item !== 'object') return null;
    var qty = Number(item.quantity) || 1;
    var linePrice =
      item.final_line_price != null
        ? item.final_line_price
        : item.line_price != null
          ? item.line_price
          : item.price != null
            ? Number(item.price) * qty
            : null;
    var unitPrice = item.price != null ? Number(item.price) : null;
    var title =
      item.product_title ||
      (item.title && String(item.title).split(' - ')[0]) ||
      '';

    return {
      ProductName: title,
      ProductID: item.product_id != null ? String(item.product_id) : undefined,
      VariantID: item.variant_id != null ? String(item.variant_id) : undefined,
      SKU: item.sku || undefined,
      Quantity: qty,
      $value: centsToDollars(linePrice != null ? linePrice : unitPrice != null ? unitPrice * qty : 0),
      Price: unitPrice != null ? centsToDollars(unitPrice) : undefined,
      ImageURL: absoluteUrl(
        item.image || (item.featured_image && item.featured_image.url) || ''
      ),
      URL: absoluteUrl(item.url || ''),
    };
  }

  var lastKey = '';
  var lastAt = 0;

  function shouldDedupe(key) {
    var now = Date.now();
    if (key === lastKey && now - lastAt < 2500) return true;
    lastKey = key;
    lastAt = now;
    return false;
  }

  function trackAddedToCart(props) {
    if (!props || !props.ProductName) return;
    window._learnq.push(['track', 'Added to Cart', props]);
  }

  function trackFromPayload(payload) {
    var props = buildPropsFromLineItem(payload);
    if (!props || !props.ProductName) return;
    var key =
      (props.VariantID || '') +
      ':' +
      (props.Quantity || 1) +
      ':' +
      (props.$value || 0);
    if (shouldDedupe(key)) return;
    trackAddedToCart(props);
  }

  // Flex PDP / <product-form>: fetch-based flow still dispatches this after flyout resolves.
  document.addEventListener('product-form:submit:success', function (e) {
    var d = e.detail;
    if (!d || !d.response) return;
    trackFromPayload(d.response);
  });

  function onJqueryReady($) {
    $(document).ajaxComplete(function (_event, xhr, settings) {
      if (!settings || !settings.url) return;
      var url = String(settings.url);
      if (url.indexOf('cart/add') === -1 && url.indexOf('cart_add') === -1) return;
      if (xhr.status < 200 || xhr.status >= 300) return;
      var raw = xhr.responseText;
      if (!raw) return;
      try {
        var data = JSON.parse(raw);
        if (data && (data.errors || data.status === 422)) return;
        trackFromPayload(data);
      } catch (_err) {
        /* not JSON */
      }
    });
  }

  function initJqueryHook() {
    if (window.jQuery) {
      onJqueryReady(window.jQuery);
      return;
    }
    window.addEventListener('load', function () {
      if (window.jQuery) onJqueryReady(window.jQuery);
    });
  }

  initJqueryHook();
})();
